import { useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormItem } from '@crossnokaye/ux-common';

import { DefrostScheduleBaseCellProps } from './defrost-schedule.types';
import { DefrostScheduleEventDayDropdown } from './defrost-schedule-event-days-dropdown';
import { DefrostTableCell } from './defrost-table-cell';

export const DefrostScheduleEventDaysCell: React.FC<DefrostScheduleBaseCellProps> = ({ index }) => {
  const { control } = useFormContext();

  return (
    <DefrostTableCell>
      {(disabledByPermissions) => (
        <FormField
          control={control}
          name={`defrostSchedule.${index}.eventDays`}
          render={({ field, fieldState: { error } }) => (
            <FormItem className="flex flex-col">
              <FormControl>
                <DefrostScheduleEventDayDropdown
                  disabled={disabledByPermissions}
                  error={error?.message}
                  onChange={field.onChange}
                  values={field.value}
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </DefrostTableCell>
  );
};
